/*  ========================================================================
    # JavaScript - Main
    ========================================================================  */

import './flynt'; // REMOVE ME LATER
import HeaderToggle from './scripts/header-toggle';
import MenuDesktop from './scripts/menu-desktop';
import MenusMobile from './scripts/menus-mobile';

const scripts = [HeaderToggle, MenuDesktop, MenusMobile];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
